module.exports = __webpack_public_path__ + "static/media/ly.402efaf8.webp";